import Joi from 'joi-browser';

const artistValidation = {
  name: Joi.string()
    .label('Nombre')
    .trim()
    .max(255)
    .required(),
  lastname: Joi.string()
    .label('Apellido')
    .trim()
    .max(255)
    .required(),
  biography: Joi.string()
    .label('Biografía')
    .trim()
    .regex(/^\W*(?:\w+\b\W*){0,110}$/)
    .required()
    .error(() => ({
      type: 'string.regex',
      message: 'Máximo 110 palabras',
    })),
  website: Joi.string()
    .label('Sitio Web')
    .uri({
      scheme: ['http', 'https'],
    })
    .allow([null, ''])
    .optional(),
  agency: Joi.string()
    .label('Agencia/Manager')
    .allow([null, ''])
    .optional(),
  agencyEmail: Joi.string()
    .label('Correo electrónico de la agencia')
    .email()
    .allow([null, ''])
    .insensitive()
    .optional(),
  agencyWeb: Joi.string()
    .label('Sitio Web de la agencia')
    .uri({
      scheme: ['http', 'https'],
    })
    .allow([null, ''])
    .optional(),
  nationality: Joi.string()
    .label('Nacionalidad')
    .required(),
  residence: Joi.string()
    .label('Nacionalidad')
    .required(),
  birthday: Joi.object()
    .label('Fecha de nacimiento')
    .required(),
  profession: Joi.string()
    .label('Profesión')
    .required(),
  specialty: Joi.string()
    .label('Especialidad')
    .allow([null, ''])
    .optional(),
  facebook: Joi.string()
    .label('Facebook')
    .uri({
      scheme: ['https'],
    })
    .regex(/.*facebook\.com.*/)
    .error(() => ({
      type: 'string.regex',
      message: 'Debe ser un enlace de Facebook',
    }))
    .allow([null, ''])
    .optional(),
  twitter: Joi.string()
    .label('Twitter')
    .uri({
      scheme: ['https'],
    })
    .regex(/.*twitter\.com.*/)
    .error(() => ({
      type: 'string.regex',
      message: 'Debe ser un enlace de Twitter',
    }))
    .allow([null, ''])
    .optional(),
  linkedin: Joi.string()
    .label('Linkedin')
    .uri({
      scheme: ['https'],
    })
    .regex(/.*linkedin\.com.*/)
    .error(() => ({
      type: 'string.regex',
      message: 'Debe ser un enlace de Linkedin',
    }))
    .allow([null, ''])
    .optional(),
  youtube: Joi.string()
    .label('Youtube')
    .uri({
      scheme: ['https'],
    })
    .regex(/.*youtube\.com.*/)
    .error(() => ({
      type: 'string.regex',
      message: 'Debe ser un enlace de Youtube',
    }))
    .allow([null, ''])
    .optional(),
  soundcloud: Joi.string()
    .label('Soundcloud')
    .uri({
      scheme: ['https'],
    })
    .regex(/.*soundcloud\.com.*/)
    .error(() => ({
      type: 'string.regex',
      message: 'Debe ser un enlace de Soundcloud',
    }))
    .allow([null, ''])
    .optional(),
  cv: Joi.array()
    .label('Curriculum Vitae')
    .max(1)
    .min(1)
    .error(() => ({
      type: 'array.min',
      message: 'Debes subir solo un archivo de CV',
    })),
  images: Joi.array()
    .label('Imágenes')
    .max(10)
    .min(1)
    .error(() => ({
      type: 'array.min',
      message: 'Debes subir al menos una imagen',
    })),
  formal_education: Joi.array()
    .label('Estudios formales')
    .required()
    .min(1)
    .error(() => ({
      type: 'array.min',
      message: 'Debes agregar al menos un estudio formal',
    })),
  informal_education: Joi.array()
    .label('Estudios informales')
    .optional(),
  support: Joi.array()
    .label('Becas y ayudas')
    .optional(),
  work_experience: Joi.array()
    .label('Experiencia de trabajo')
    .optional(),
  achievements: Joi.array()
    .label('Reconocimientos')
    .optional(),
  clips: Joi.array()
    .label('Recortes de prensa')
    .optional(),
  videos: Joi.array()
    .label('Videos')
    .optional(),
  interests: Joi.array()
    .label('Intereses')
    .optional(),
};

export default artistValidation;



// WEBPACK FOOTER //
// ./src/containers/Profile/EditProfile/artistValidation.js